//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.InspectionMoveBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[1,"ApproachDist",0,"CAM.InheritableDoubleBuilder",0],[0,"DepthDistance",1,0],[0,"DepthMethod",1,0],[0,"EndDistance",0,"CAM.InheritableDoubleBuilder",0],[0,"EndPercentage",0,"CAM.InheritableDoubleBuilder",0],[0,"Pitch",0,"CAM.InheritableDoubleBuilder",0],[1,"RetractDist",0,"CAM.InheritableDoubleBuilder",0],[0,"Reversedirection",1,0],[0,"Revolutions",0,"CAM.InheritableDoubleBuilder",0],[0,"ScanModeType",1,0],[1,"ScanSpeed",0,"CAM.InheritableDoubleBuilder",0],[0,"StartDistance",0,"CAM.InheritableDoubleBuilder",0],[0,"StartEndMode",1,0],[0,"StartPercentage",0,"CAM.InheritableDoubleBuilder",0],[1,"StepSize",0,"CAM.InheritableDoubleBuilder",0],[0,"Sweep",0,"CAM.InheritableDoubleBuilder",0],[0,"TurnDirection",1,0],[0,"TurnType",1,0]],[],[]];
SPLM.CAM.InspectionScanHelixBuilder = class extends SPLM.CAM.InspectionMoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionScanHelixBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;